import { render, staticRenderFns } from "./card-call.vue?vue&type=template&id=70105966&scoped=true"
import script from "./card-call.vue?vue&type=script&lang=js"
export * from "./card-call.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70105966",
  null
  
)

export default component.exports